module.exports = __webpack_public_path__ + "img/order_form_image@3x.c1bb3845.png";